module.exports = {"411222100":"大营镇","411222101":"原店镇","411222102":"西张村镇","411222103":"观音堂镇","411222200":"张汴乡","411222201":"张湾乡","411222203":"菜园乡","411222205":"张茅乡","411222206":"王家后乡","411222207":"硖石乡","411222210":"西李村乡","411222211":"宫前乡","411222212":"店子乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411222.json
// module id = 1492
// module chunks = 0